import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * Shared base for all /api/v2 REST services.
 * Provides the base URL and a standard error handler.
 */
@Injectable()
export abstract class RestApiBaseService {

  protected get v2Base(): string {
    return environment.restV2URI.replace(/\/$/, '') + '/api/v2';
  }

  protected handleError(err: HttpErrorResponse): Observable<never> {
    const message =
      (err.error as { message?: string })?.message ??
      err.message ??
      'An unexpected error occurred';
    return throwError(() => new Error(message));
  }

  /** Normalise a list payload: AEP List `{ results }` or a bare array → plain array. */
  protected toList<T>(data: T[] | { results?: T[] } | null | undefined): T[] {
    if (Array.isArray(data)) return data;
    return data?.results ?? [];
  }

  /** Returns only columns that have an active filter (_ids, search, or query set). */
  protected activeFilters(cols: unknown[] | undefined): unknown[] | undefined {
    if (!Array.isArray(cols) || cols.length === 0) return undefined;
    const active = (cols as Record<string, unknown>[]).filter(c => {
      if (Array.isArray(c['_ids']) && (c['_ids'] as unknown[]).length > 0) return true;
      if (typeof c['search'] === 'string' && c['search'] !== '') return true;
      const q = c['query'] as Record<string, unknown> | null | undefined;
      return !!(q?.['first_value'] ?? q?.['second_value']);
    });
    return active.length ? active : undefined;
  }
}
